<template>
    <div class="page-wrap-">
        <v-sheet class="px-1 pt-1 w-full h-full">
            <div class="d-flex flex-wrap justify-space-between-- mt-2 align-center">
                <img
                        height="40px"
                        class="mx-6"
                        src="@/assets/images/custom-logo-w.png"
                        alt=""
                    />
                <div>Workspace</div>
                <v-btn @click="autoAssign()" dark icon color="black" style="margin-left: 100px; text-transform: none; background-color: #ffd700; color: black; border-radius: 5% 5%;width: 200px">
                    <v-icon class="mr-1">mdi-google-circles-extended</v-icon>
                    Αυτόματη Ανάθεση
                </v-btn>                
                <v-btn @click="previewResult" dark icon style="margin-left: 400px; text-transform: none; background-color: #3878c7; border-radius: 5% 5%;width: 200px">
                    <v-icon class="mr-2">mdi-send-variant</v-icon>
                    Δημοσίευση
                </v-btn>
                <div style="flex-grow:1">&nbsp;</div>                
                <v-btn @click.stop="resetConfirmDialog=true" dark icon color="black" outlined style="margin-right: 20px; text-transform: none; border-radius: 5% 5%; width: 140px;">
                    <v-icon>mdi-delete</v-icon>
                    Καθαρισμός
                </v-btn>
            </div>
            <div class="ma-2 d-flex align-stretch h-full" style="height: calc(100vh - 80px) !important">
                <div class="wsp-column-technician">
                    <div class="wsp-title">
                        Επιλογή Τεχνικού >
                    </div>
                    <div class="wsp-toolbar" style="font-weight: bold; font-size: 0.9em;">
                        {{ selectedTechnician ? selectedTechnician.username : "" }}
                        <br/>
                        {{ selectedTechnician ? selectedTechnician.firstName : "" }} {{ selectedTechnician ? selectedTechnician.lastName : "" }}
                    </div>
                    <div class="wsp-list">
                        <vue-perfect-scrollbar
                            :settings="{ suppressScrollX: true, wheelPropagation: false }"
                            class="h-100 rtl-ps-none ps scroll"
                            style="height: 100%"
                        >
                            <technician-card v-for="tech in filtered_technicians" :key="tech.username" :technician="tech" :selectedTechnician="selectedTechnician" @clickcard="selectTechnician(tech)" @eject="toggleExcludeTechnician(tech)"></technician-card>
                        </vue-perfect-scrollbar>                        
                    </div>
                </div>
                <div class="wsp-column">
                    <div class="wsp-title">                        
                        <v-img style="float: left; margin-top: 2px;  margin-right: 4px;" :src="markers.route" width="26px"></v-img>  Δρομολόγιο
                    </div>
                    <div class="wsp-toolbar">
                        <!--<v-btn @click="releaseAppointment(focusedAppointment)" outlined small icon color="red" style="text-transform: none; color: red; border-radius: 5px; margin: 5%; width: 90%;">
                            <v-icon>mdi-cancel</v-icon>
                            Αφαίρεση
                        </v-btn>
                        <v-btn small @click="assignAppointments(focusedAppointment)" dark icon color="black" style="text-transform: none; background-color: #ffd700; color: black; border-radius: 5px; margin: 5%; width: 90%;">
                            <v-icon x-small>mdi-keyboard-return</v-icon>
                            Ανάθεση
                        </v-btn>-->
                        <!--<v-btn-toggle>
                            <v-btn x-small>
                            <v-icon x-small>mdi-chevron-double-down</v-icon>
                            </v-btn>

                            <v-btn x-small>
                            <v-icon x-small>mdi-chevron-down</v-icon>
                            </v-btn>
                            <v-btn x-small>
                                <v-icon x-small>mdi-chevron-up</v-icon>
                            </v-btn>

                            <v-btn x-small>                            
                            <v-icon x-small>mdi-chevron-double-up</v-icon>
                            </v-btn>
                        </v-btn-toggle>-->
                    </div>
                    <div class="wsp-list" >
                        <vue-perfect-scrollbar
                            :settings="{ suppressScrollX: true, wheelPropagation: false }"
                            class="h-100 rtl-ps-none ps scroll"
                            style="height: 100%;"
                        >
                            <appointment-card v-for="appt in filtered_assigment" :key="appt.id +'_rou'" :selectedTechnician="selectedTechnician" :isroute="true" :appointment="appt" :selectedAppointment="focusedAppointment" @clickcard="focusAppointment(appt)" @selectedchanged="selectAppointment"></appointment-card>
                        </vue-perfect-scrollbar>                        
                    </div>
                </div>

                <div class="wsp-narrow-column">
                        <div class="wsp-title details">
                            <v-icon class="ml-1 mr-1">mdi-watch</v-icon> Ώρα
                        </div>
                        <div class="wsp-toolbar">

                        </div>
                        <div class="wsp-list">                            
                            <v-btn small style="font-weight: bold;" width="95" class="quickbutton mt-2 ml-1" 
                                @click="setTime(sl)"
                                :class="{selected: focusedAppointment && focusedAppointment.assignment && (focusedAppointment.assignment.appoint_timeslot == sl)}" 
                                v-for="sl in ref_timeslots" :key="sl">
                                {{ sl }}
                            </v-btn>
                        </div>
                    </div>
                <div class="wsp-details">
                    <div class="wsp-title details">
                        <v-icon class="mr-2 ml-2">mdi-card-account-details</v-icon>Λεπτομέρειες Ραντεβού
                    </div>
                    <div class="wsp-toolbar">
                        
                        <!--<v-btn @click="releaseAppointment(focusedAppointment)" small outlined color="black" icon style="text-transform: none; border-radius: 5px; margin-bottom: 10px; margin-top: 10px; width: 90%;">
                            <v-icon small class="mr-2">mdi-cancel</v-icon>
                            Ακύρωση
                        </v-btn>-->

                        <v-menu
                            bottom
                            :offset-x="true"
                            >
                            <template v-slot:activator="{ on, attrs }">                                
                                <v-btn v-bind="attrs" v-on="on" small outlined color="black" icon style="text-transform: none; border-radius: 5px; margin-bottom: 10px; margin-top: 10px; width: 90%;">
                                    <v-icon small class="mr-2">mdi-format-list-bulleted-type</v-icon>
                                    Άλλες Ενέργειες
                                </v-btn>
                            </template>

                            <v-list v-if="currentlyFocusedAppointment">
                                <v-list-item v-if="!currentlyFocusedAppointment.ing_cancel" @click="cancelAppointmentByCustomer">
                                    <v-list-item-title><v-icon color="red">mdi-cancel</v-icon> <span class="mt-2 ml-2">Ακύρωση Απο Πελάτη</span></v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="!currentlyFocusedAppointment.ing_cancel" @click="cancelAppointmentByAdmin">
                                    <v-list-item-title><v-icon color="red">mdi-cancel</v-icon> <span class="mt-2 ml-2">Ακύρωση Απο Admin</span></v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="currentlyFocusedAppointment.ing_cancel" @click="uncancelAppointment">
                                    <v-list-item-title><v-icon color="black">mdi-arrow-left</v-icon><v-icon color="black">mdi-cancel</v-icon> <span class="mt-2 ml-2">Αναίρεση Ακύρωσης</span></v-list-item-title>
                                </v-list-item>                                
                                <v-list-item v-if="currentlyFocusedAppointment.ing_excluded" @click="unexcludeAppointment">
                                    <v-list-item-title><v-icon color="black">mdi-arrow-left</v-icon><v-icon color="black">mdi-eject-circle-outline</v-icon> <span class="mt-2 ml-2">Αναίρεση Εξαίρεσης Από Αυτόμ. Ανάθεση</span></v-list-item-title>
                                </v-list-item>
                                <v-list-item v-else @click="excludeAppointment">
                                    <v-list-item-title><v-icon color="red">mdi-eject-circle-outline</v-icon> <span class="mt-2 ml-2">Εξαίρεση Από Αυτόμ. Ανάθεση</span></v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>                                                
                        <v-btn v-if="currentlyFocusedAppointmentIsAssigned" @click="releaseAppointment(currentlyFocusedAppointment)" small outlined color="red" icon style="text-transform: none; border-radius: 5px; margin-bottom: 10px; width: 90%;">
                            <v-icon small class="mr-2">mdi-account-off-outline</v-icon>
                            Αφαίρεση Ανάθεσης
                        </v-btn>
                        <v-btn v-else small @click="assignAppointments(currentlyFocusedAppointment)" dark icon color="black" style="text-transform: none; background-color: #ffd700; color: black; border-radius: 10px; margin-bottom: 5px; width: 90%;">
                            <v-icon small>mdi-keyboard-return</v-icon>
                            Ανάθεση
                        </v-btn>
                        
                       
                    </div>                    
                    <div class="wsp-list">
                        <vue-perfect-scrollbar
                            :settings="{ suppressScrollX: true, wheelPropagation: false }"
                            class="h-100 rtl-ps-none ps scroll"
                            style="min-height: 75vh;max-height: 75vh;"
                        >
                            <v-card class="ma-1 mt-2 pa-0" style="padding-bottom: 200px;">
                                <v-card-text v-if="currentlyFocusedAppointment" style="padding: 4px;">
                                    <span class="dynfield-label">ΠΕΛΑΤΗΣ:</span>
                                    <span class="dynfield-value" style=" ">{{currentlyFocusedAppointment.customer_name}}</span>
                                    
                                    <span class="dynfield-label">ΤΗΛΕΦΩΝΟ:</span> 
                                    <span class="dynfield-value">{{currentlyFocusedAppointment.customer_phone}}</span>
                                    
                                    <span class="dynfield-label">ΔΙΕΥΘΥΝΣΗ:</span>
                                    <span class="dynfield-value">{{currentlyFocusedAppointment.loc_address}}, {{currentlyFocusedAppointment.loc_city}}, {{currentlyFocusedAppointment.loc_zip}} , {{currentlyFocusedAppointment.loc_district}}</span>

                                    <template v-if="currentlyFocusedAppointment.asn_visit_info">
                                        <hr class="mt-4" />
                                        <hr/>
                                        <span>ΕΠΙΠΛΕΟΝ ΠΛΗΡΟΦΟΡΙΕΣ: </span> 
                                        <hr/>
                                        <hr/>            
                                        <v-btn small dark block style="background-color: #444; " @click="edittime(currentlyFocusedAppointment)">ΕΠΕΞΕΡΓΑΣΙΑ</v-btn>
                                        <span class="dynfield-label">ΣΧΟΛΙΑ:</span>                                         
                                        <span class="dynfield-value">{{currentlyFocusedAppointment.asn_visit_info.asn_comments}}</span>
                                        <span class="dynfield-label">ΟΡΟΦΟΣ:</span> 
                                        <span class="dynfield-value">{{currentlyFocusedAppointment.asn_visit_info.asn_floor}}</span>
                                        <span class="dynfield-label">ΚΟΥΔΟΥΝΙ:</span> 
                                        <span class="dynfield-value">{{currentlyFocusedAppointment.asn_visit_info.asn_doorbell_info}}</span>
                                    </template>
                                    <v-btn class="mt-2" v-else dark small block style="background-color: #444" @click="edittime(currentlyFocusedAppointment)">+ ΕΠΙΠΛΕΟΝ ΠΛΗΡΟΦΟΡΙΕΣ</v-btn>
                                    
                                    <template v-if="(currentlyFocusedAppointment.ing_locked_reason.length && currentlyFocusedAppointment.ing_locked_reason.length) || (currentlyFocusedAppointment.appt_category && currentlyFocusedAppointment.appt_category.length) || (currentlyFocusedAppointment.ing_cancel_reason && currentlyFocusedAppointment.ing_cancel_reason.length)">
                                        <hr class="mt-4" />
                                        <hr/>
                                        <span>ΧΑΡΑΚΤΗΡΙΣΜΟΙ:</span>
                                        <hr/>
                                        <hr/>                                    
                                        <span v-if="currentlyFocusedAppointment" class="dynfield-value" style=" ">
                                            <v-chip small style="background-color: #3878c7; color: white;" v-for="c in currentlyFocusedAppointment.appt_category" :key="c" class="ml-2 mt-1">{{ c }}</v-chip>
                                        </span>
                                        <span v-if="currentlyFocusedAppointment && currentlyFocusedAppointment.ing_locked_reason && currentlyFocusedAppointment.ing_locked_reason.length" class="dynfield-label">ΚΛΕΙΔΩΜΕΝΟ:</span>
                                        <span class="dynfield-value" style=" ">
                                            <v-chip small style="background-color: #3878c7; color: white;" v-for="c in currentlyFocusedAppointment.ing_locked_reason" :key="c" class="ml-2 mt-1">{{ c }}</v-chip>
                                        </span>
                                        <span v-if="currentlyFocusedAppointment && currentlyFocusedAppointment.ing_cancel_reason && currentlyFocusedAppointment.ing_cancel_reason.length" class="dynfield-label">ΑΚΥΡΩΜΕΝΟ:</span>
                                        <span class="dynfield-value" style=" ">
                                            <v-chip small style="background-color: red; color: white;" v-for="c in currentlyFocusedAppointment.ing_cancel_reason" :key="c" class="ml-2 mt-1">{{ c }}</v-chip>
                                        </span>
                                    </template>                                    

                                    <hr class="mt-4"/>
                                    <hr/>
                                    <span>ΥΠΗΡΕΣΙΕΣ:</span>
                                    <hr/>
                                    <hr/>
                                    <p v-for="(workitem, index) in currentlyFocusedAppointment.work_items" :key="index" style="border-bottom: 2px solid lightgrey">        
                                        <span class="dynfield-label">ΣΧΟΛΙΑ ΓΡΑΜΜΑΤΕΙΑΣ:</span>
                                        <span class="dynfield-value">{{workitem.backoffice_comments}}</span>  

                                        <span class="dynfield-label">ΠΑΡΑΣΤΑΤΙΚΟ:</span>
                                        <span class="dynfield-value">{{workitem.invoice}}</span>                                        

                                        <span class="dynfield-label">ΠΑΡΑΣΤ. ΠΡΟΜΗΘΕΥΤΗ:</span>
                                        <span class="dynfield-value">{{workitem.supplier_document_number}}</span>                                        

                                        <span class="dynfield-label">ΚΩΔ. ΥΠΗΡΕΣΙΑ:</span>
                                        <span class="dynfield-value">{{workitem.system_work_code}}</span>                                        

                                        <span class="dynfield-label">ΠΕΡΙΓΡΑΦΗ ΥΠΗΡΕΣΙΑΣ:</span>
                                        <span class="dynfield-value">{{workitem.system_work_name}}</span>                                                                                                                                                                

                                        <span class="dynfield-label">ΠΟΣΟΤΗΤΑ:</span>
                                        <span class="dynfield-value">{{workitem.work_material_qty}}</span>

                                        <span class="dynfield-label">ΠΕΡΙΓΡΑΦΗ ΥΛΙΚΟΥ:</span>
                                        <span class="dynfield-value">{{workitem.work_material_descr}}</span>

                                        <span class="dynfield-label">ΠΡΟΜΗΘΕΥΤΗΣ:</span>
                                        <span class="dynfield-value">{{workitem.supplier}}</span>
                                    </p>

                                    <!--<div style="font-size: 0.9em; font-weight: bold; text-wrap: wrap; overflow: hidden;"
                                        class="d-flex- justify-space-between- align-center- flex-wrap- mb-4-"
                                    >
                                        {{ selectedAppointment ? JSON.stringify(selectedAppointment, null, 2) : {} }}
                                        <br/>                
                                    </div>                        -->
                                </v-card-text>
                            </v-card>
                        </vue-perfect-scrollbar>
                    </div>
                </div>

                <div class="wsp-column-appointments">
                    <div class="wsp-title">
                        <v-img style="float: left; margin-top: 2px; margin-right: 4px;" :src="markers.normal" width="26px"></v-img> Προς Ανάθεση &nbsp;&nbsp; {{ filtered_appointments.length }}                        
                    </div>
                    <div class="wsp-toolbar">
                        
                    </div>
                    <div class="wsp-list">
                        <vue-perfect-scrollbar
                            :settings="{ suppressScrollX: true, wheelPropagation: false }"
                            class="h-100 rtl-ps-none ps scroll"
                            style="height: 100%;  padding-right: 5px;"
                        >                                                 
                            <appointment-card v-for="appt in filtered_appointments" :key="appt.id" :appointment="appt"  :selectedAppointment="focusedAppointment" @clickcard="focusAppointment(appt)" @selectedchanged="selectAppointment"></appointment-card>
                        </vue-perfect-scrollbar>                        
                    </div>
                </div>
                
                <div class="wsp-map">                    
                    <omnimapx v-model="location" :pois="pois" :focusedpoi="focusedAppointment" @focusAppointment="focusAppointment"></omnimapx>
                    
                </div>
            </div>
        </v-sheet>

        <v-dialog
            v-model="editAppointmentDialog"
            max-width="500px"
          >
            <!--<template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                + New Item
              </v-btn>
            </template>-->
            <v-card>
              <v-card-title>
                <span class="text-h5">Επεξεργασία</span>
              </v-card-title>
  
              <v-card-text v-if="editedAppointment">
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"                      
                    >
                        <v-textarea
                            v-model="editedAppointment.asn_visit_info.asn_comments"
                            label="ΣΧΟΛΙΑ"
                        ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"                      
                    >
                        <v-text-field
                            v-model="editedAppointment.asn_visit_info.asn_floor"
                            label="ΟΡΟΦΟΣ"
                        ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"                      
                    >
                        <v-text-field
                            v-model="editedAppointment.asn_visit_info.asn_doorbell_info"
                            label="ΚΟΥΔΟΥΝΙ"
                        ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
  
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeEditTime"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="saveEditTime"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        <v-dialog
            v-model="resetConfirmDialog"
            max-width="290"
            >
            <v-card>
                <v-card-title class="text-h5">
                Προσοχή ⚠
                </v-card-title>

                <v-card-text>
                Είστε σίγουρος/η ότι θέλετε να ΣΒΗΣΕΤΕ όλες τις αντιστοιχίες που έχετε κάνει μέχρι τώρα??
                </v-card-text>

                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    color="blue darken-1"
                    text
                    @click="()=> { resetConfirmDialogΝο() }"
                >
                    OXI
                </v-btn>

                <v-btn
                    dark
                    color="blue"                    
                    @click="resetConfirmDialogYes"
                >
                    NAI
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
      v-model="pleasewaitoverlaydialog"

      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Παρακαλώ Περιμένετε
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <OverviewDialog :opendialog="overviewdialog" :batchcode="code" @closedialog="overviewdialog=false"></OverviewDialog>
    </div>
    
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import {api, srvApi, srvApiNoAuth, PATH, getAssetUrl} from "src/api/index";
import axios from 'axios';

//import Omnimap from './components/omnimapbox.vue';
//import '@site/src/node_modules/mapbox-gl/dist/mapbox-gl.css';
//import './components/mapbox-gl.css';

import omnimapx from "./components/omnimapx";

//import TechnicianCard from "@/views/external/components/technician-card";
import TechnicianCard from './components/technician-card.vue';
import AppointmentCard from './components/appointment-card.vue';
import OverviewDialog from './components/overviewdialog.vue';

const markerss = {
    normal: require("src/assets/images/marker_normal.svg"),
    normal_focused: require("src/assets/images/marker_normal_focused.svg"),
    selected: require("src/assets/images/marker_selected.svg"),
    selected_focused: require("src/assets/images/marker_selected_focused.svg"),
    route: require("src/assets/images/marker_route.svg"),
    route_focused: require("src/assets/images/marker_route_focused.svg"),
    start: require("src/assets/images/marker_start.svg"),
};


export default {
    name: 'workspace',
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Workspace'
    },
    components: {
        "technician-card": TechnicianCard,
        "appointment-card": AppointmentCard,        
        omnimapx,
        OverviewDialog
        //MglMap
    },
    data() {
  
        return {         
            overviewdialog: false,
            pleasewaitoverlaydialog: false,
            editedAppointment: null,
            editAppointmentDialog: false,
            resetConfirmDialog: false,             
            filtassignretrigger: 0, 
            markers: markerss,

            location: {
                lng: -71.224518,
                lat: 42.213995,
                bearing: 0,
                pitch: 0,
                zoom: 9
            },

            code: null,
            technicians: [],
            appointments: [],
            assignment: [],
            assignments: {},

            selectedTechnician: null,
            selectedAppointment: null,    
            focusedAppointment: null,        



            show: false,
            password: '',
            checkbox1: true,
            checkbox2: false,
            email: '',
            ePassword: '',            
            loading: false,
            emailRules: [
                (v) => !!v || 'E-mail is required',
                (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
            ],
            nameRules: [
                (v) => !!v || 'Password is required',
               
            ],

            ref_timeslots: [                
                "08:00 - 10:00",
                "09:00 - 11:00",
                "10:00 - 12:00",
                "11:00 - 13:00",
                "12:00 - 14:00",
                "13:00 - 15:00",
                "14:00 - 16:00",
                "15:00 - 17:00",
                "16:00 - 18:00",
                "17:00 - 19:00",
                "18:00 - 20:00",
                "19:00 - 21:00",
                "20:00 - 22:00",
                "21:00 - 23:00",
            ]
        }
    },
    computed: {
        currentlyFocusedAppointment() {
            let b = this.filtassignretrigger;

            let c = this.focusedAppointment ? this.focusedAppointment.id : 0;
            let rslt = this.appointments.find(a=>a.id == c);
            return rslt;
        },
        currentlyFocusedAppointmentIsAssigned() {
            let b = this.filtassignretrigger;

            let c = this.focusedAppointment ? this.focusedAppointment.id : 0;

            for(let techUsername in this.assignments){
                for(let asgn of this.assignments[techUsername]){
                    if(asgn.appointment.id == c) {
                        return true;
                    }                           
                }
            }
            return false;
        },
        //...mapGetters(['loggedInUser', 'error'])
        filtered_technicians() {
            return this.technicians;
        },
        
        pois() {
            //return this.appointments;
            /*
            if(this.selectedTechnician) {
                return this.appointments.filter(x=>x.technician_code != this.selectedTechnician.username);
            }
            else {
                return this.appointments;   
            }
                */
            const normalpois=[];
            const epoc = new Date().getTime();
            if(this.selectedTechnician) {
                normalpois.push(...this.appointments.filter(x=>x.technician_code != this.selectedTechnician.username).map(a=>({...a, route:false, orderno: 0, randcode: epoc})));
            }
            else {
                normalpois.push(...this.appointments.map(a=>({...a, route:false, orderno: 0, randcode: epoc})));
            }  

            const routepois=[];
            let test = this.filtassignretrigger;
            let idx=0;
            if(this.selectedTechnician && this.assignments && this.assignments[this.selectedTechnician.username]) {
                //return this.assignments[this.selectedTechnician.username];
                let apptIdList = this.assignments[this.selectedTechnician.username].map(a=>a.appointment.id);                                
                for(let id of apptIdList) {
                    let appt = this.appointments.find(a=>a.id == id);
                    idx++;
                    if (appt) routepois.push({...appt, route:true, orderno: idx, randcode: epoc });
                }                
                //return this.appointments.filter(x=> apptIdList.includes(x.id))
            }                        

            /*if(this.selectedTechnician) {
                const routeList = 
                for(let i=0; i<)
                routepois.push(...this.appointments.filter(x=>x.technician_code == this.selectedTechnician.username).map(a=>({...a, route:true, orderno: 10, randcode: epoc})));
            }*/

            let rslt = [...normalpois, ...routepois];        
            
            let coords = null;
            if(this.selectedTechnician && this.selectedTechnician.starting_point_json.coordinates && this.selectedTechnician.starting_point_json.coordinates) {
                coords = {
                    lat: this.selectedTechnician.starting_point_json.coordinates[1],
                    lng: this.selectedTechnician.starting_point_json.coordinates[0]
                };     
                rslt.push({startplace: true, route:false, info: {coords}, randcode: epoc});                           
            }
            
            return rslt;
        },
        // technicianpois() {
        //     const rslt=[];
        //     if(this.selectedTechnician) {
        //         rslt.push(...this.appointments.filter(x=>x.technician_code == this.selectedTechnician.username).map(a=>({...a})));
        //     }
        //     else {                
        //         //do nothing;   
        //     }   
        //     return rslt;         
        // },
        filtered_appointments() {
            let test = this.filtassignretrigger;
            return this.appointments.filter(x=>x.technician_code == "" || x.technician_code == null);
        },
        filtered_assigment() {
            let test = this.filtassignretrigger;
            if(this.selectedTechnician && this.assignments && this.assignments[this.selectedTechnician.username]) {                
                //let apptIdList = this.assignments[this.selectedTechnician.username].map(a=>a.appointment.id);
                let asnList = this.assignments[this.selectedTechnician.username].map(a=>({...a}));
                //console.log("apptIdList: " + JSON.stringify(apptIdList));
                let appts = [];
                for(let asn of asnList) {
                    let appt = this.appointments.find(a=>a.id == asn.appointment.id);
                    if (appt) appts.push({...appt, assignment: asn});
                }
                return appts;
                //return this.appointments.filter(x=> apptIdList.includes(x.id))
            }            
            else {
                return [];
            }
        }
    },
    methods: {
        previewResult() {
            // const rsp = await srvApiNoAuth.get(PATH.ASSIGNMENT_PREVIEWRESULT + "/" + this.code);
            // console.log(JSON.stringify(rsp.data, null, 2));


            this.overviewdialog = true;

            /*

            axios({
            method: "get",
            url: "/api/" + PATH.ASSIGNMENT_PREVIEWRESULT + "/" + this.code,
            responseType: "blob",
            })
            .then((response) => {
                const url = window.URL.createObjectURL(
                new Blob([response.data])
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "preview_data.xls");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
                console.error("Error during Download", error);
            });
            */
        },
        async autoAssign() {
            try {
                this.pleasewaitoverlaydialog=true;
                const rsp = await srvApiNoAuth.post(PATH.ASSIGNMENT_AUTOCALC + "/" + this.code, {});
                await this.reloadEverything();  
            } catch (error) {
                
            }
            finally{
                this.pleasewaitoverlaydialog=false;
            }

        
        },  

        closeEditTime(){
            this.editedAppointment = null;
            this.editAppointmentDialog = false;
        },
        async saveEditTime(){
            //await this.setTime(this.editedAppointment.assignment, this.editedAppointment.id);
            await this.updateAppointmentVisitInfo();
            this.editedAppointment = null;
            this.editAppointmentDialog = false;
        },
        edittime(apptToEdit) {            
            if(!this.focusedAppointment.asn_visit_info) {
                this.focusedAppointment.asn_visit_info = {
                    asn_comments: "",
                    asn_floor: "",
                    asn_doorbell_info: ""
                }
            }
            this.editedAppointment = this.focusedAppointment;
            this.editAppointmentDialog = true;            
        },
        async resetConfirmDialogYes() {
            this.pleasewaitoverlaydialog=true;
            await this.resetBatch();
            this.resetConfirmDialog = false;
            this.pleasewaitoverlaydialog=false;
        },
        async resetConfirmDialogΝο() {
            this.resetConfirmDialog = false;

        },
        async cancelAppointmentByCustomer() {
            this.pleasewaitoverlaydialog=true;
            try {
                const rsp = await srvApiNoAuth.patch(PATH.ASSIGNMENT_APPOINTMENT + "/" + this.code, {
                    id: this.focusedAppointment.id,
                    ing_cancel: true,
                    ing_cancel_reason: ["ΑΚΥΡΩΣΗ ΠΕΛΑΤΗ"]
                });
                await this.reloadEverything();
            } catch (error) {
                alert("ΣΥΝΕΒΕΙ ΣΦΑΛΜΑ: " + (error.code ? error.code : " ") + " | " + (error.description ? error.description : " ") + " | " + (error.message ? error.message : " "));
            }
            finally {                
                this.pleasewaitoverlaydialog=false;
                this.filtassignretrigger++;
                this.$forceUpdate();
            }            
        },
        async cancelAppointmentByAdmin() {
            this.pleasewaitoverlaydialog=true;
            try {
                const rsp = await srvApiNoAuth.patch(PATH.ASSIGNMENT_APPOINTMENT + "/" + this.code, {
                    id: this.focusedAppointment.id,
                    ing_cancel: true,
                    ing_cancel_reason: ["ΑΚΥΡΩΣΗ ΑΠΟ ADMIN"]
                });
                await this.reloadEverything();
            } catch (error) {
                alert("ΣΥΝΕΒΕΙ ΣΦΑΛΜΑ: " + (error.code ? error.code : " ") + " | " + (error.description ? error.description : " ") + " | " + (error.message ? error.message : " "));
            }
            finally {                
                this.pleasewaitoverlaydialog=false;
                this.filtassignretrigger++;
                this.$forceUpdate();
            }
        },
        async uncancelAppointment() {
            this.pleasewaitoverlaydialog=true;
            try {
                const rsp = await srvApiNoAuth.patch(PATH.ASSIGNMENT_APPOINTMENT + "/" + this.code, {
                    id: this.focusedAppointment.id,
                    ing_cancel: false,
                    ing_cancel_reason_rem: ["ΑΚΥΡΩΣΗ ΠΕΛΑΤΗ", "ΑΚΥΡΩΣΗ ΑΠΟ ADMIN"]
                });
                await this.reloadEverything();
            } catch (error) {
                alert("ΣΥΝΕΒΕΙ ΣΦΑΛΜΑ: " + (error.code ? error.code : " ") + " | " + (error.description ? error.description : " ") + " | " + (error.message ? error.message : " "));
            }
            finally {                
                this.pleasewaitoverlaydialog=false;
                this.filtassignretrigger++;
                this.$forceUpdate();
            }
        },

        async excludeAppointment() {
            this.pleasewaitoverlaydialog=true;
            try {
                const rsp = await srvApiNoAuth.patch(PATH.ASSIGNMENT_APPOINTMENT + "/" + this.code, {
                    id: this.focusedAppointment.id,
                    ing_excluded: true                    
                });
                await this.reloadEverything();
            } catch (error) {
                alert("ΣΥΝΕΒΕΙ ΣΦΑΛΜΑ: " + (error.code ? error.code : " ") + " | " + (error.description ? error.description : " ") + " | " + (error.message ? error.message : " "));
            }
            finally {                
                this.pleasewaitoverlaydialog=false;
                this.filtassignretrigger++;
                this.$forceUpdate();
            }
        },

        async unexcludeAppointment() {
            this.pleasewaitoverlaydialog=true;
            try {
                const rsp = await srvApiNoAuth.patch(PATH.ASSIGNMENT_APPOINTMENT + "/" + this.code, {
                    id: this.focusedAppointment.id,
                    ing_excluded: false                    
                });
                await this.reloadEverything();
            } catch (error) {
                alert("ΣΥΝΕΒΕΙ ΣΦΑΛΜΑ: " + (error.code ? error.code : " ") + " | " + (error.description ? error.description : " ") + " | " + (error.message ? error.message : " "));
            }
            finally {                
                this.pleasewaitoverlaydialog=false;
                this.filtassignretrigger++;
                this.$forceUpdate();
            }
        },

        async updateAppointmentVisitInfo() {
            this.pleasewaitoverlaydialog=true;
            try {
                const rsp = await srvApiNoAuth.patch(PATH.ASSIGNMENT_APPOINTMENT + "/" + this.code, {
                    id: this.focusedAppointment.id,
                    asn_visit_info: this.focusedAppointment.asn_visit_info
                });
                await this.reloadEverything();
            } catch (error) {
                alert("ΣΥΝΕΒΕΙ ΣΦΑΛΜΑ: " + (error.code ? error.code : " ") + " | " + (error.description ? error.description : " ") + " | " + (error.message ? error.message : " "));
            }
            finally {                
                this.pleasewaitoverlaydialog=false;
                this.filtassignretrigger++;
                this.$forceUpdate();
            }
        },

        async reloadEverything() {
            const rsp = await srvApiNoAuth.get(PATH.ASSIGNMENT_BATCH + "/" + this.code);
            this.technicians.splice(0, this.technicians.length);
            this.technicians.push(...rsp.data.technicians.map(x=>({
                ...x,
                total_estim_duration: 0,
                total_services_count: 0,
                assignment: [],
                focusedAppointment: null
            })));
            this.appointments.splice(0, this.appointments.length);
            this.appointments.push(...rsp.data.appointments.map(x=>({
                ...x,
                technician_code: null,            
                info: {
                    coords: {lat: x.geocoords.coordinates[1], lng: x.geocoords.coordinates[0]},
                    marker: "normal"
                },
                selected: false,
                prelocked: false,
                prelocked_time: false,
                locked: false
            })));
            this.assignments = rsp.data.manual_assignments;
            this.updateAppointmentsWithAssignmentData(this.assignments);
        },
        async resetBatch() {
            const rspReset = await srvApiNoAuth.post(PATH.ASSIGNMENT_RESETBATCH + "/" + this.code);

            await this.reloadEverything();            
        },        

        
        async setTime(targetTimeslot) {   
            if(this.currentlyFocusedAppointment && this.currentlyFocusedAppointment.ing_locked_reason && Array.isArray(this.currentlyFocusedAppointment.ing_locked_reason) && this.currentlyFocusedAppointment.ing_locked_reason.find(r=>r.includes('ΧΡΟΝΟΣ')) ) {
                alert("Απαγορεύεται η αφαίρεση ανάθεσης γιατί υπάρχει ΚΛΕΙΔΩΜΑ σε ΧΡΟΝΟ");
                return;
            }
            this.pleasewaitoverlaydialog=true;
            try {
                let preresp = true
                if(!this.currentlyFocusedAppointmentIsAssigned) {
                    preresp = await this.assignAppointments(this.currentlyFocusedAppointment);
                }
                if(!preresp) {
                    return;
                }
                if(!this.currentlyFocusedAppointment) {
                    alert("Επιλέξτε πρώτα ένα ραντεβού");
                }
                const payload = {
                    technician: this.selectedTechnician.username,//assignment.technician,
                    assignments: [{id: this.currentlyFocusedAppointment.id}],
                    tgt_appoint_timeslot: targetTimeslot
                }
                const rspSetTime = await srvApiNoAuth.post(PATH.ASSIGNMENT_SETTIME + "/" + this.code, payload);
                this.assignments = rspSetTime.data.manual_assignments;            
                this.updateAppointmentsWithAssignmentData(this.assignments);              
                for(let asgn of this.filtered_assigment){
                    if(asgn.id == this.currentlyFocusedAppointment.id) {                             
                        this.focusedAppointment = asgn;
                        return;
                    }                           
                }                        
                this.filtassignretrigger++;
                this.$forceUpdate();
            } catch (error) {
                alert("ΣΥΝΕΒΕΙ ΣΦΑΛΜΑ: " + (error.code ? error.code : " ") + " | " + (error.description ? error.description : " ") + " | " + (error.message ? error.message : " "));
            }
            finally {                
                this.pleasewaitoverlaydialog=false;
                this.filtassignretrigger++;
                this.$forceUpdate();
            }                                 
        },


        //update input appointments assignment fields from 'manual_assignments' before responding
        updateAppointmentsWithAssignmentData(assignmentData){
            for(let techUsername in assignmentData){
                for(let asgn of assignmentData[techUsername]){
                    let tgtIndex = this.appointments.findIndex(a=>a.id == asgn.appointment.id);
                    if(tgtIndex>=0){
                        this.appointments[tgtIndex].technician_code = techUsername;
                    }                      
                }
            }
        },
        // updateAppointmentsWithLockData(lockData){
        //     for(let appt of this.appointments){
        //         const prelock = lockData.prelocks.find(d=>d.appointment_id==appt.id);
        //         if(prelock) {                    
        //             appt.prelocked=true;
        //             appt.technician_code=prelock.technician;
        //             if(prelock.timeslot) {
        //                 appt.prelocked_time = true;
        //                 appt.appoint_timeslot = prelock.timeslot;
        //             }
        //         }                
        //     }
        // },
        async toggleExcludeTechnician(targetedTechnician) {
            try {                
                targetedTechnician.excludedLoading = true;
                if(targetedTechnician.excluded) {
                    const rsp = await srvApiNoAuth.post(PATH.ASSIGNMENT_INCLUDETECHNICIAN + "/" + this.code, {technician: targetedTechnician.username});
                    targetedTechnician.excluded=false;
                }
                else {
                    const rsp = await srvApiNoAuth.post(PATH.ASSIGNMENT_EXCLUDETECHNICIAN + "/" + this.code, {technician: targetedTechnician.username});
                    targetedTechnician.excluded=true;
                }                
            } catch (error) {
                
            }
            finally {
                targetedTechnician.excludedLoading = false;
            }            
        },
        selectTechnician(tech) {
            this.selectedTechnician = tech;
        },
        selectAppointment({id, selected}) {
            let apt = this.appointments.find(x=>x.id == id);            
            if(apt) {                
                apt.selected = selected;
            }
            //this.selectedAppointment = appt;
        },
        focusAppointment(appt) {
            this.focusedAppointment = appt;
        },
        async releaseAppointment(appt) {
            if(!appt) {
                alert("Πρέπει πρώτα να κλικάρετε το ραντεβού που θέλετε να αφαιρέσετε.");
                return;
            }
            if(appt.ing_locked_reason && Array.isArray(appt.ing_locked_reason) && appt.ing_locked_reason.find(r=>r.includes('ΤΕΧΝΙΚΟΣ')) ) {
                alert("Απαγορεύεται η αφαίρεση ανάθεσης γιατί υπάρχει ΚΛΕΙΔΩΜΑ σε ΤΕΧΝΙΚΟ");
                return;
            }
            const rsp = await srvApiNoAuth.post(PATH.ASSIGNMENT_REMOVE + "/" + this.code, {technician: this.selectedTechnician.username, appointmentid: appt.id});            
            this.appointments.forEach(a=>a.selected=false);
            let tgtAppt = this.appointments.find(a=>a.id==appt.id);
            if(tgtAppt) {
                tgtAppt.technician_code = null;
            }
            if(this.assignments == null) {
                this.assignments = {};
            }
            this.assignments[this.selectedTechnician.username] = rsp.data.manual_assignments[this.selectedTechnician.username];
            //this.updateAppointmentsWithAssignmentData(this.assignments);
            this.filtassignretrigger++;
            this.$forceUpdate();
        },
        async assignAppointments(appt) {   
            if(this.selectedTechnician == null) {
                alert("Πρέπει πρώτα να επιλέξετε έναν Τεχνικό.");
                return false;
            }
            //how to find previousApptId: Is List Empty? Put on first position
            // // Is List not empty but nothing is selected? Put on last position
            // // Is List not empty but an appointment is selected? Put on right after position
            let previousApptId=0;
            // const currentlyAssignedAppts = [...this.appointments.filter(x=>x.technician_code == this.selectedTechnician.username)];            
            // const focusedAssignment = this.focusedAppointment ? currentlyAssignedAppts.find(x=>x.id == this.focusedAppointment.id) : null;
            // if(currentlyAssignedAppts.length>0) {
            //     if(!focusedAssignment) { 
            //         previousApptId = 0; //currentlyAssignedAppts[currentlyAssignedAppts.length-1].id;                    
            //     }
            //     else {
            //         previousApptId = focusedAssignment.id;
            //     }
            // }


            // const assignmentCommand = {
            //     technician: this.selectedTechnician.username,
            //     assignments: [...this.appointments.filter(x=>x.selected == true)],
            //     previousApptId
            // };
            if(!this.currentlyFocusedAppointment) {
                alert("Πρέπει πρώτα να επιλέξετε ένα Ραντεβού.");
                return;
            }

            const assignmentCommand = {
                technician: this.selectedTechnician.username,
                assignments: [this.currentlyFocusedAppointment],
                previousApptId
            };
            const rsp = await srvApiNoAuth.post(PATH.ASSIGNMENT_MANUALASSIGNTECH + "/" + this.code, assignmentCommand);            
            //this.appointments.forEach(a=>a.selected=false);
            if(this.assignments == null) {
                this.assignments = {};
            }
            this.assignments[this.selectedTechnician.username] = rsp.data.manual_assignments[this.selectedTechnician.username];
            this.updateAppointmentsWithAssignmentData(this.assignments);
            this.filtassignretrigger++;
            this.$forceUpdate();
            return true;
        },
        // ...mapActions(['login']),
        // formSubmit() {     
        //     //this.error = '';       
        //     this.login({username: this.email, password: this.ePassword})            
        // },        
    },
    watch: {
        // loading (val) {
        //   if (!val) return
        //   setTimeout(() => (this.loading = false), 2000)
        // },
        // loggedInUser(val) {
        //     if (val && val.token && val.token.length > 0) {
        //         // this.makeToast("success", "Successfully Logged In");
        //         console.log('logged in successfully ')
        //         this.loading = true
        //         setTimeout(() => {
        //             this.$router.push('/')
        //         }, 500)
        //     }
        // },
        // error(val) {            
        //     if (val != null) {
        //         this.error = val.message;                
        //     }
        // }
    },
    created() {
        this.code = this.$route.params.code;
        // We need to set mapbox-gl library here in order to use it in template
        //this.mapbox = Mapbox;
    },
    async mounted() {
        const rsp = await srvApiNoAuth.get(PATH.ASSIGNMENT_BATCH + "/" + this.code);
        this.technicians.push(...rsp.data.technicians.map(x=>({
            ...x,
            total_estim_duration: 0,
            total_services_count: 0,
            assignment: [],
            focusedAppointment: null
        })));
        this.appointments.push(...rsp.data.appointments.map(x=>({
            ...x,
            technician_code: null,            
            info: {
                coords: {lat: x.geocoords.coordinates[1], lng: x.geocoords.coordinates[0]},
                marker: "normal"
            },
            selected: false,
            prelocked: false,
            prelocked_time: false,
            locked: false
        })));
        this.assignments = rsp.data.manual_assignments;
        this.updateAppointmentsWithAssignmentData(this.assignments);
        //console.log(JSON.stringify(rsp.data, null, 2));
    }
}
</script>
<style lang="scss" scoped>

.quickbutton {
    background-color: #ffd700 !important;
    color: black;    
}

.quickbutton.selected {
    background-color: #444 !important;
    color: white;
}

.quickbutton:hover {
    background-color:gray !important;
    color: white;
}

.dynfield-label {
    display:block;
    font-size: 10px;
    font-weight: bold;
    line-height: 12px;
    margin-top: 15px;
    color: #444;
}

.dynfield-value {
    display:block;
    overflow: hidden;
    text-wrap-mode: wrap; 
    text-wrap-style: wrap;
    text-wrap: wrap;
    color: #222;   
    font-size: 16px; 
}


.wsp-title {
    height: 40px;
    line-height: 32px;
    //border-bottom: 1px solid lightgray;
    padding: 4px;
    font-weight: bold;
    font-size: 0.9em;
    vertical-align: middle;    
}

.wsp-title.details {
    background-color: #92ff5f;
}

.wsp-toolbar {
    height: 110px;
    //border-bottom: 1px solid lightgray;
    align-items:center;
    text-align: center;
}

.wsp-column-appointments{
    border: 1px solid lightgray;
    min-width: 240px;
    max-width: 240px;

}

.wsp-column {
    border: 1px solid lightgray;
    min-width: 300px;
    max-width: 300px;

}

.wsp-column-technician {
    border: 1px solid lightgray;
    min-width: 180px;
    max-width: 180px;

}

.wsp-narrow-column {
    //border: 1px solid lightgray;
    min-width: 100px;
    max-width: 100px;

}

.wsp-list {
    height: calc(100% - 150px);    
    //background-color: lightblue;
    //overflow: scroll;
}

.wsp-map {
    //border: 1px solid lightgray;
    min-width: calc(100vw - 1180px);
}

.wsp-details {
    //border: 1px solid lightgray;
    min-width: 320px;
}

.page-wrap {
    //background-color: #242939 !important;
    background-color: #f2f4f4 !important;
    display: flex;
    align-items: center;
    padding: 40px 1rem;
    height: 100%;
    min-height: 100vh;
}
.session-form-hold {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
}
</style>
